import { Component, Vue, Prop, Provide } from 'vue-property-decorator';
import { OrderDetailsModel, ProductModel, OrderDetailResponseModel } from './orderdetails.model';
import { orderDocumentService } from './OrderDetails.services';
import OrderList from '../OrderList/OrderList.vue';


@Component({
  components:{
    OrderList,
  }
})
export default class OrderDetails extends Vue{
    public fullPage: boolean = true;
    public orderDetailsModel!: OrderDetailsModel;
    public orderDetailResponse!: OrderDetailResponseModel;
    public productModel!: ProductModel;
    public Result: number = 0;
    public submitted: boolean = false;
    public errorMessage: string = '';
    public buttonDisabled: boolean = false;
    public $loading: any
    public data() {
        return {
            orderDetailsModel: new OrderDetailsModel(),
            orderDetailResponse: new OrderDetailResponseModel(),
            submitted: false,
            errorMessage: '',
            buttonDisabled: false

        };
      }
    constructor(){
        super();
    }

    mounted():void{
        console.log("Login Form successfully mounted");   
    }

    listOrder(e: Event){
        e.preventDefault();
        this.buttonDisabled = true;
        console.log("Form submitted");
        this.submitted = true;
            this.$validator.validate().then(valid => {
                if (valid) {
                  this.errorMessage = '';
                    this.orderListing();
                }else{
                  this.buttonDisabled = false;
                }
            });       
    }
    clearSEMessage(){
      this.errorMessage = '';
    }

    addOrderDetails(orderDetails: any) {
      this.$store.dispatch("addOrderDetails", orderDetails);
      console.log(this.$store);
    }

    public async orderListing(): Promise<void> {
        let orderDetails =JSON.stringify(this.orderDetailsModel);
        let parsedData = JSON.parse(orderDetails)
        let data = {
          data: parsedData
        }
        const self = this;
        //----------------------------
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        
        const Res = orderDocumentService
          .GetOrderDocument(data)
          .then((response: any) => {
            loader.hide();
            this.buttonDisabled = false;
            self.Result = response.status;
            this.orderDetailResponse = <OrderDetailResponseModel>response.data['data']['order_details'];
            console.log(this.orderDetailResponse.amount);
            let data = JSON.stringify(this.orderDetailResponse);
            localStorage.setItem("orderDetails",data);
            console.log(this.orderDetailResponse.product[0].product_name);
            this.$router.push('/list');
            this.addOrderDetails(this.orderDetailResponse);        
          })
          .catch((error: any) => {
            self.Result = error;
            this.buttonDisabled = false;
            if(this.errorMessage === ''){
            this.errorMessage = error.response.data['data']['message'];
            }
            else{
              this.errorMessage === '';
              this.errorMessage = error.response.data['data']['message'];
            }
            loader.hide()
          });   
       
      }
}
